import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import './ShoptetApplicationDetail.scss';

export default class TooltipButton extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        delay: PropTypes.number,
        disabled: PropTypes.bool,
        onClick: PropTypes.func,
        placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        tooltipText: PropTypes.any.isRequired
    };

    static defaultProps = {
        className: 'btn btn-default',
        placement: 'bottom',
        delay: 100,
        disabled: false
    };

    render() {
        const { delay, tooltipText, className, onClick, children, placement, disabled, ...otherProps } = this.props;

        const tooltip = (
            <Tooltip className="panelTooltip dark-tooltip" id="tooltip" positionTop={10}>
                {tooltipText}
            </Tooltip>
        );

        return (
            <OverlayTrigger
                delay={delay}
                overlay={tooltip}
                placement={placement}
            >
                <button
                    className={`${className} shoptet-application-detail__tooltip-button`}
                    disabled={disabled}
                    onClick={onClick}
                    {...otherProps}
                >
                    <span className="shoptet-application-detail__tooltip-button-content">
                        {children}
                    </span>
                </button>
            </OverlayTrigger>
        );
    }
}
